export const TABS = ["Route Progress", "Shipment", "Documents"];
export const STRINGS = {
    buttonText: "Let's talk about it",
    quoteNumber: "Quote no.",
};
